import {navigate} from 'vike/client/router';

// Drop-in replacement for preact-iso's useLocation(), scoped to the one
// method every call site actually uses: programmatic navigation. (Nothing in
// the app reads .path/.query/.url off the old hook — those all go through
// window.location directly elsewhere.)
export function useLocation() {
    return {
        route: (url) => navigate(url),
    };
}
